// Cloud Functions base URL for the relocated DashAI admin panel.
//
// apps/web set VITE_FIREBASE_FUNCTIONS_URL at build time; apps/admin does not.
// Prefer the env var when present, otherwise derive the URL from the active
// Firebase project id so the admin app is self-contained per environment.
//
// The fallback region MUST match where the functions actually deploy —
// europe-west3 (FUNCTIONS_REGION for all dashpet-* projects, next to the
// Frankfurt ClickHouse). A us-central1 fallback resolves to a non-existent host,
// so every admin function call fails with no CORS headers (surfacing as a "CORS
// error") whenever the env var is unset — notably local `npm run dev`.
import { projectId } from '@/utils/firebase';

export const FUNCTIONS_BASE =
  (import.meta.env.VITE_FIREBASE_FUNCTIONS_URL as string | undefined) ||
  `https://europe-west3-${projectId}.cloudfunctions.net`;

// Trailing-slash-trimmed base, matching how the panel concatenates `${base}/path`.
export const getFunctionsBase = (): string => FUNCTIONS_BASE.replace(/\/+$/, '');
